import styled from 'styled-components';
import { Icon } from './Icon';
interface CheckBoxProps {
  checkIdArray: string[];
  setCheckIdArray: (checkIdArray: string[]) => void;
  checkValue: string;
}

const CheckBox = ({
  checkIdArray,
  setCheckIdArray,
  checkValue,
}: CheckBoxProps) => {
  return (
    <>
      <Wrap>
        <input
          type="checkbox"
          id={checkValue}
          onChange={(e) => {
            if (e.target.checked) {
              setCheckIdArray([...checkIdArray, checkValue]);
            } else {
              setCheckIdArray(checkIdArray.filter((id) => id !== checkValue));
            }
          }}
          checked={checkIdArray.includes(checkValue)}
        />
        <label className="flex aic jcc img-box" htmlFor={checkValue}>
          {checkIdArray.includes(checkValue) ? (
            <Icon name="CheckActiveIcon" size="100%" color="#757575" />
          ) : (
            <Icon name="CheckIcon" size="100%" color="#757575" />
          )}
        </label>
      </Wrap>
    </>
  );
};

export default CheckBox;

const Wrap = styled.div`
  width: 20px;
  height: 20px;
  min-width: 20px;
  max-height: 20px;
  > input {
    display: none;
  }
  > label {
    display: block;
    width: 100%;
    height: 100%;
  }
`;
